const initialDocumentData = () => ({
    id: null,
    statusId: 10,
    proposedDate: null,
    productionDepartmentId: null,
    typeId: null,
    createdBy: {},
    attachments: [],
    comments: [],
    usersWithAccess: [],
})

export default initialDocumentData
